export default {
  club_name: 'Nybro Vikings',
  club_name_short: 'NYBRO',
  stadium_name: 'Liljas Arena',
  staging_url: 'https://nybro.api.fangroup.io',
  prod_url: 'https://nybro.api.fangroup.io',
  api: '/api',
  facebook: 'nybrovikings',
  basename: '/nybro',
  club_logo: '/assets/teams/nybro.png',
  app_name: 'nybro',
  websale_name: 'nybro',
  ntb_team_id: 10019,
  microservice_url: 'https://stats.api.fangroup.io',
  currencyCaps: 'SEK',
  currencyShort: 'Kr',
  currencyShortSmall: 'kr',
  clubSportalityAvailable: false,
  leagueSportalityAvailable: false,
  cloudIdName: 'nybro',
  monolithEnabled: false,
};
